<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html,body{
    margin: 0;
    padding: 0;
  }

  .longMsgStyle{
    margin: 0 auto;
    width: 60%;
    left: 0!important;
    right: 0!important;
    transform: translate(-0%, -50%)!important;

    /*background-color: rgba(253,254,255,.2)!important;*/
  }
  .mint-toast-text {
    font-size: 16px!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue